// Timer op het bord (oprichter 1 okt 2026): de ronde knop naast het weer, het instelvel en het
// alarm. Kort en rustig; de labels zijn vaste keuzes (niets typen op het bord).
export const kioskTimerNl = {
    open: 'Timer',
    openRunning: 'Timer: nog {time}',
    title: 'Timer',
    minutes: '{n} min',
    custom: 'Zelf kiezen',
    less: 'Een minuut minder',
    more: 'Een minuut meer',
    minutesUnit: 'minuten',
    forWhat: 'Waarvoor?',
    labels: {
        teeth: 'Tanden poetsen',
        homework: 'Huiswerk',
        screen: 'Schermtijd',
        cooking: 'Koken',
    },
    start: 'Start',
    left: 'Nog {time}',
    paused: 'Gepauzeerd',
    pause: 'Pauze',
    resume: 'Verder',
    plusOne: '+1 min',
    stop: 'Stop',
    done: 'Tijd is om!',
    /** Rustig, buiten het thema Kinderen. */
    doneCalm: 'De tijd is om',
};
//# sourceMappingURL=kioskTimer.nl.js.map